import React from 'react';

export interface RouteConfig {
  path: string;
  component: React.LazyExoticComponent<React.ComponentType<any>>;
  props?: Record<string, any>;
}

export const LANDING_ROUTES = ['#', '#features', '#ai-assistant', '#pricing', '#about'];

export const dashboardRoutes: RouteConfig[] = [
  // ─── AR Hub Routes (point to first page of each group) ──────────────
  {
    path: '#ar-customers',
    component: React.lazy(() => import('../features/customers/components/CustomerManagement')),
  },
  {
    path: '#ar-invoicing',
    component: React.lazy(() => import('../features/invoicing/components/InvoicingView')),
  },
  {
    path: '#ar-payments',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARPaymentRecordingView')),
  },
  {
    path: '#ar-credit',
    component: React.lazy(() => import('../features/credit/components/CreditManagement')),
  },
  {
    path: '#ar-reports',
    component: React.lazy(() => import('../features/aging/components/AgingReports')),
  },
  // ─── AR Detail Routes ─────────────────────────────────────────────────
  {
    path: '#customer-mgmt',
    component: React.lazy(() => import('../features/customers/components/CustomerManagement')),
  },
  {
    path: '#ar-communications',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARCommunicationsView')),
  },
  {
    path: '#ar-reminders',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARRemindersView')),
  },
  {
    path: '#ar-customer-portal',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARCustomerPortalView')),
  },
  {
    path: '#invoicing',
    component: React.lazy(() => import('../features/invoicing/components/InvoicingView')),
  },
  {
    path: '#ar-recurring-invoices',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARRecurringInvoicesView')),
  },
  {
    path: '#ar-templates',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARTemplatesView')),
  },
  {
    path: '#ar-estimates',
    component: React.lazy(() => import('../features/accounts-receivable/components/AREstimatesView')),
  },
  {
    path: '#ar-payment-recording',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARPaymentRecordingView')),
  },
  {
    path: '#ar-payment-plans',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARPaymentPlansView')),
  },
  {
    path: '#ar-online-payments',
    component: React.lazy(() => import('../features/accounts-receivable/components/AROnlinePaymentsView')),
  },
  {
    path: '#credit-mgmt',
    component: React.lazy(() => import('../features/credit/components/CreditManagement')),
  },
  {
    path: '#ar-collections',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARCollectionsView')),
  },
  {
    path: '#ar-dunning',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARDunningView')),
  },
  {
    path: '#ar-credit-exposure',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARCreditExposureView')),
  },
  {
    path: '#ar-ai-collections',
    component: React.lazy(() => import('../features/accounts-receivable/components/AIPredictiveCollectionsView')),
  },
  {
    path: '#aging-reports',
    component: React.lazy(() => import('../features/aging/components/AgingReports')),
  },
  {
    path: '#ar-statements',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARStatementsView')),
  },
  {
    path: '#ar-revenue-reports',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARRevenueReportsView')),
  },
  {
    path: '#ar-bank-recon',
    component: React.lazy(() => import('../features/accounts-payable/components/BankReconciliationView')),
  },
  {
    path: '#ar-rev-recognition',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARRevenueRecognitionView')),
  },
  {
    path: '#ar-consolidated',
    component: React.lazy(() => import('../features/accounts-receivable/components/ARConsolidatedView')),
  },
  {
    path: '#vendor-mgmt',
    component: React.lazy(() => import('../features/vendors/components/VendorManagement')),
  },
  {
    path: '#purchase-orders',
    component: React.lazy(() => import('../features/accounts-payable/components/PurchaseOrdersView')),
  },
  {
    path: '#goods-receiving',
    component: React.lazy(() => import('../features/accounts-payable/components/GoodsReceivingView')),
  },
  {
    path: '#bill-processing',
    component: React.lazy(() => import('../features/accounts-payable/components/BillProcessingView')),
  },
  {
    path: '#payment-processing',
    component: React.lazy(() => import('../features/accounts-payable/components/PaymentProcessingView')),
  },
  {
    path: '#expense-reports',
    component: React.lazy(() => import('../features/accounts-payable/components/ExpenseReportsView')),
  },
  {
    path: '#ap-aging',
    component: React.lazy(() => import('../features/accounts-payable/components/APAgingView')),
  },
  {
    path: '#vendor-statements',
    component: React.lazy(() => import('../features/accounts-payable/components/VendorStatementsView')),
  },
  {
    path: '#recurring-bills',
    component: React.lazy(() => import('../features/accounts-payable/components/RecurringBillsView')),
  },
  {
    path: '#bill-scanner',
    component: React.lazy(() => import('../features/accounts-payable/components/BillScannerView')),
  },
  {
    path: '#bank-feeds',
    component: React.lazy(() => import('../features/accounts-payable/components/BankFeedView')),
  },
  {
    path: '#vendor-portal',
    component: React.lazy(() => import('../features/accounts-payable/components/VendorPortalView')),
  },
  {
    path: '#ap-procurement',
    component: React.lazy(() => import('../features/accounts-payable/components/PurchaseRequisitionsView')),
  },
  {
    path: '#ap-bills',
    component: React.lazy(() => import('../features/accounts-payable/components/BillProcessingView')),
  },
  {
    path: '#ap-vendors',
    component: React.lazy(() => import('../features/vendors/components/VendorManagement')),
  },
  {
    path: '#ap-banking',
    component: React.lazy(() => import('../features/accounts-payable/components/BankFeedView')),
  },
  {
    path: '#ap-reports',
    component: React.lazy(() => import('../features/accounts-payable/components/APAgingView')),
  },
  {
    path: '#purchase-requisitions',
    component: React.lazy(() => import('../features/accounts-payable/components/PurchaseRequisitionsView')),
  },
  {
    path: '#vendor-performance',
    component: React.lazy(() => import('../features/accounts-payable/components/VendorPerformanceView')),
  },
  {
    path: '#scheduled-payments',
    component: React.lazy(() => import('../features/accounts-payable/components/ScheduledPaymentsView')),
  },
  {
    path: '#bank-reconciliation',
    component: React.lazy(() => import('../features/accounts-payable/components/BankReconciliationView')),
  },
  {
    path: '#audit-trail',
    component: React.lazy(() => import('../features/accounts-payable/components/AuditTrailView')),
  },
  {
    path: '#ap-analytics',
    component: React.lazy(() => import('../features/accounts-payable/components/APReportsView')),
  },
  {
    path: '#ap-consolidated',
    component: React.lazy(() => import('../features/accounts-payable/components/APConsolidatedView')),
  },
  {
    path: '#ap-supply-chain',
    component: React.lazy(() => import('../features/accounts-payable/components/APSupplyChainView')),
  },
  {
    path: '#integrations',
    component: React.lazy(() => import('../features/settings/components/IntegrationHubView')),
  },
  {
    path: '#tax-rules',
    component: React.lazy(() => import('../features/settings/components/TaxRulesView')),
  },
  {
    path: '#chart-accounts',
    component: React.lazy(() => import('../features/general-ledger/components/chart-of-accounts/ChartOfAccountsView')),
  },
  {
    path: '#journal-entries',
    component: React.lazy(() => import('../features/general-ledger/components/journal-entries/JournalEntriesView')),
  },
  {
    path: '#trial-balance',
    component: React.lazy(() => import('../features/general-ledger/components/trial-balance/TrialBalanceView')),
  },
  {
    path: '#account-recon',
    component: React.lazy(() => import('../features/general-ledger/components/account-recon/ReconciliationView')),
  },
  {
    path: '#recurring-transactions',
    component: React.lazy(() => import('../features/recurring/components/RecurringTransactionsView')),
  },
  {
    path: '#period-closing',
    component: React.lazy(() => import('../features/closing/components/PeriodClosingView')),
  },
  {
    path: '#financial-statements',
    component: React.lazy(() => import('../features/reports/components/FinancialReportsView')),
  },
  {
    path: '#statement-equity',
    component: React.lazy(() => import('../features/reports/components/StatementOfEquityView')),
  },
  {
    path: '#financial-ratios',
    component: React.lazy(() => import('../features/reports/components/FinancialRatiosView')),
  },
  {
    path: '#ai-insights',
    component: React.lazy(() => import('../features/reports/components/AIInsightsView')),
  },
  {
    path: '#custom-reports',
    component: React.lazy(() => import('../features/reports/components/CustomReportBuilderView')),
  },
  {
    path: '#mgmt-dashboard',
    component: React.lazy(() => import('../features/reports/components/ManagementDashboardView')),
  },
  {
    path: '#cash-position',
    component: React.lazy(() => import('../features/cash-management/components/CashPositionView')),
  },
  {
    path: '#unified-cashflow',
    component: React.lazy(() => import('../features/cash-management/components/UnifiedCashFlowView')),
  },
  {
    path: '#alerts-dashboard',
    component: React.lazy(() => import('../features/dashboard/components/AlertsDashboardView')),
  },
  {
    path: '#treasury',
    component: React.lazy(() => import('../features/cash-management/components/TreasuryView')),
  },
  {
    path: '#payment-matching',
    component: React.lazy(() => import('../features/cash-management/components/PaymentMatchingView')),
  },
  {
    path: '#netting',
    component: React.lazy(() => import('../features/cash-management/components/NettingView')),
  },
  {
    path: '#parallel-accounting',
    component: React.lazy(() => import('../features/general-ledger/components/ParallelAccountingView')),
  },
  {
    path: '#help',
    component: React.lazy(() => import('../features/help/components/HelpCenter')),
  },
  {
    path: '#admin-toggles',
    component: React.lazy(() => import('../features/settings/components/FeatureTogglesView')),
  },
  {
    path: '#cash-flow-forecast',
    component: React.lazy(() => import('../features/cash-management/components/CashFlowForecastView')),
  },
  {
    path: '#bank-accounts',
    component: React.lazy(() => import('../features/cash-management/components/BankAccountsView')),
  },
  {
    path: '#cash-transactions',
    component: React.lazy(() => import('../features/cash-management/components/CashTransactionsView')),
  },
  {
    path: '#cost-dashboard',
    component: React.lazy(() => import('../features/cost-management/components/CostManagementView')),
  },
  {
    path: '#cost-centers',
    component: React.lazy(() => import('../features/cost-management/components/CostManagementView')),
  },
  {
    path: '#cost-tracking',
    component: React.lazy(() => import('../features/cost-management/components/CostManagementView')),
  },
  {
    path: '#cost-analysis',
    component: React.lazy(() => import('../features/cost-management/components/CostManagementView')),
  },
  {
    path: '#budget-dashboard',
    component: React.lazy(() => import('../features/budgeting/components/BudgetingView')),
  },
  {
    path: '#budget-planning',
    component: React.lazy(() => import('../features/budgeting/components/BudgetingView')),
  },
  {
    path: '#budget-monitoring',
    component: React.lazy(() => import('../features/budgeting/components/BudgetingView')),
  },
  {
    path: '#budget-analysis',
    component: React.lazy(() => import('../features/budgeting/components/BudgetingView')),
  },
  {
    path: '#inventory-dashboard',
    component: React.lazy(() => import('../features/inventory/components/InventoryView')),
  },
  {
    path: '#products-stock',
    component: React.lazy(() => import('../features/inventory/components/InventoryView')),
  },
  {
    path: '#warehouse',
    component: React.lazy(() => import('../features/inventory/components/InventoryView')),
  },
  {
    path: '#inventory-analysis',
    component: React.lazy(() => import('../features/inventory/components/InventoryView')),
  },
  {
    path: '#asset-register',
    component: React.lazy(() => import('../features/fixed-assets/components/FixedAssetsView')),
  },
  {
    path: '#depreciation',
    component: React.lazy(() => import('../features/fixed-assets/components/FixedAssetsView')),
  },
  {
    path: '#asset-disposal',
    component: React.lazy(() => import('../features/fixed-assets/components/FixedAssetsView')),
  },
  {
    path: '#asset-reports',
    component: React.lazy(() => import('../features/fixed-assets/components/FixedAssetsView')),
  },
  {
    path: '#employee-mgmt',
    component: React.lazy(() => import('../features/payroll/components/PayrollView')),
  },
  {
    path: '#time-attendance',
    component: React.lazy(() => import('../features/payroll/components/PayrollView')),
  },
  {
    path: '#payroll-processing',
    component: React.lazy(() => import('../features/payroll/components/PayrollView')),
  },
  {
    path: '#benefits-mgmt',
    component: React.lazy(() => import('../features/payroll/components/PayrollView')),
  },
  {
    path: '#tax-compliance',
    component: React.lazy(() => import('../features/payroll/components/PayrollView')),
  },
  {
    path: '#payroll-reports',
    component: React.lazy(() => import('../features/payroll/components/PayrollView')),
  },
  {
    path: '#payroll-settings',
    component: React.lazy(() => import('../features/payroll/components/PayrollView')),
  },
  {
    path: '#ai-analytics',
    component: React.lazy(() => import('../features/payroll/components/PayrollView')),
  },
  {
    path: '#workflow-automation',
    component: React.lazy(() => import('../features/payroll/components/PayrollView')),
  },
  {
    path: '#tax-scraper-mgmt',
    component: React.lazy(() => import('../features/payroll/components/PayrollView')),
  },
  {
    path: '#tax-setup',
    component: React.lazy(() => import('../features/tax-management/components/TaxManagementView')),
  },
  {
    path: '#tax-calculations',
    component: React.lazy(() => import('../features/tax-management/components/TaxManagementView')),
  },
  {
    path: '#tax-returns',
    component: React.lazy(() => import('../features/tax-management/components/TaxManagementView')),
  },
  {
    path: '#tax-reports',
    component: React.lazy(() => import('../features/tax-management/components/TaxManagementView')),
  },
  {
    path: '#smart-analysis',
    component: React.lazy(() => import('../features/ai-assistant/components/AIAssistantView')),
  },
  {
    path: '#automated-reports',
    component: React.lazy(() => import('../features/ai-assistant/components/AIAssistantView')),
  },
  {
    path: '#predictive-analytics',
    component: React.lazy(() => import('../features/ai-assistant/components/AIAssistantView')),
  },
  {
    path: '#ai-recommendations',
    component: React.lazy(() => import('../features/ai-assistant/components/AIAssistantView')),
  },
  {
    path: '#risk-assessment',
    component: React.lazy(() => import('../features/internal-control/components/InternalControlView')),
  },
  {
    path: '#fraud-detection',
    component: React.lazy(() => import('../features/internal-control/components/InternalControlView')),
  },
  {
    path: '#audit-trail',
    component: React.lazy(() => import('../features/internal-control/components/InternalControlView')),
  },
  {
    path: '#compliance-monitoring',
    component: React.lazy(() => import('../features/internal-control/components/InternalControlView')),
  },
  {
    path: '#control-testing',
    component: React.lazy(() => import('../features/internal-control/components/InternalControlView')),
  },
  {
    path: '#bi',
    component: React.lazy(() => import('../features/business-intelligence/components/BIView')),
  },
  {
    path: '#dashboard-analytics',
    component: React.lazy(() => import('../features/business-intelligence/components/BIView')),
  },
  {
    path: '#kpi-monitoring',
    component: React.lazy(() => import('../features/business-intelligence/components/BIView')),
  },
  {
    path: '#performance-metrics',
    component: React.lazy(() => import('../features/business-intelligence/components/BIView')),
  },
  {
    path: '#data-viz',
    component: React.lazy(() => import('../features/business-intelligence/components/BIView')),
  },
  {
    path: '#settings-main',
    component: React.lazy(() => import('../features/settings/components/SettingsView')),
  },
  {
    path: '#company-settings',
    component: React.lazy(() => import('../features/settings/components/SettingsView')),
  },
  {
    path: '#user-mgmt',
    component: React.lazy(() => import('../features/settings/components/SettingsView')),
  },
  {
    path: '#sys-config',
    component: React.lazy(() => import('../features/settings/components/SettingsView')),
  },
  {
    path: '#backup-restore',
    component: React.lazy(() => import('../features/settings/components/SettingsView')),
  },
  {
    path: '#plan-billing',
    component: React.lazy(() => import('../features/settings/components/PlanBilling')),
  },
  {
    path: '#currency-mgmt',
    component: React.lazy(() => import('../features/settings/components/CurrencyManagement')),
  },
  {
    path: '#data-mgmt',
    component: React.lazy(() => import('../features/data/components/DataManagementView')),
  },
];
